import { render, staticRenderFns } from "./HotCmpt.vue?vue&type=template&id=4cce2828&scoped=true&"
import script from "./HotCmpt.vue?vue&type=script&lang=js&"
export * from "./HotCmpt.vue?vue&type=script&lang=js&"
import style0 from "./HotCmpt.vue?vue&type=style&index=0&id=4cce2828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cce2828",
  null
  
)

export default component.exports